import React from 'react'
import PropTypes from 'prop-types'
import Slide from './Slide'
import './ListSlide.css'

class ListSlide extends Slide {

    render() {
        
        const nodes = this.props.list
            .map(item => (
                <li>
                    {item.title && <b>{item.title + ': '}</b>}
                    {item.text}
                    {item.link && <a href={item.link.href}>{' ' + item.link.text}</a>}
                </li>
            ))

        return super.render(
            <div className='ListSlide'>
                <span className='ListSlide-Title'>{ this.props.title }</span>
                
                {this.props.ordered ? 
                <ol>
                    { nodes }
                </ol>
                :
                <ul>
                    { nodes }
                </ul>
                }
                <img src={this.props.img} />
            </div>
        )
    }
}
 
ListSlide.propTypes = {
    title: PropTypes.string.isRequired,
    img: PropTypes.string.isRequired,
    list: PropTypes.array.isRequired,
    ordered: PropTypes.bool
}

export default ListSlide;



// WEBPACK FOOTER //
// ./src/components/ListSlide.js